<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="center">
			<v-col class="text-center" cols="12">
				<img :src="code" ref="zok" />
			</v-col>
		</v-row>
		<v-row align="center">
			<v-col class="text-center" cols="12">
				<div class="my-2">
					<v-btn
						small
						:disabled="loading"
						color="primary"
						@click="fetchLogin"
					>
						Press here after QRCode scan.</v-btn
					>
				</div>
				<div>
					all right reserved © 2020 ZION SOCIAL SERVICE – YUK LAI HIN
					COUNSELLING CENTRE by TWM;
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import axios from "axios";
import router from "@/router";
export default {
	data() {
		return {
			loading: true,
			isLogined: false,
			code:
				"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg==",
		};
	},
	mounted() {
		this.fetchLogin();
	},
	methods: {
		fetchLogin() {
			let _self = this;
			this.loading = true;
			axios
				.get(
					"https://secureim.ylh.org.hk/srv2/getqr.php"
				)
				.then((response) => {
					let ecc = response.data;
					console.log(ecc);
					if (ecc.accountStatus == "authenticated") {
						router.push({ path: "/private/chat" });
					}
					if (ecc.accountStatus != "qr") {
						router.push({ path: "/private/connect" });
					}
					if (ecc.qrCode) {
						this.code = ecc.qrCode;
						this.loading = false;
					}
				});
		},
	},
};
</script>
